export default __webpack_public_path__ + "static/media/atul.32e78221.png";